/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SecurityAccessFeaturesEnum } from './SecurityAccessFeaturesEnum';
import {
    SecurityAccessFeaturesEnumFromJSON,
    SecurityAccessFeaturesEnumFromJSONTyped,
    SecurityAccessFeaturesEnumToJSON,
} from './SecurityAccessFeaturesEnum';

/**
 * 
 * @export
 * @interface AccessIntermediaryViewModel
 */
export interface AccessIntermediaryViewModel {
    /**
     * 
     * @type {string}
     * @memberof AccessIntermediaryViewModel
     */
    intermediaryCode: string;
    /**
     * 
     * @type {string}
     * @memberof AccessIntermediaryViewModel
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AccessIntermediaryViewModel
     */
    lastName: string;
    /**
     * 
     * @type {Array<SecurityAccessFeaturesEnum>}
     * @memberof AccessIntermediaryViewModel
     */
    features: Array<SecurityAccessFeaturesEnum>;
}

/**
 * Check if a given object implements the AccessIntermediaryViewModel interface.
 */
export function instanceOfAccessIntermediaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "intermediaryCode" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "features" in value;

    return isInstance;
}

export function AccessIntermediaryViewModelFromJSON(json: any): AccessIntermediaryViewModel {
    return AccessIntermediaryViewModelFromJSONTyped(json, false);
}

export function AccessIntermediaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessIntermediaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intermediaryCode': json['IntermediaryCode'],
        'firstName': json['FirstName'],
        'lastName': json['LastName'],
        'features': ((json['Features'] as Array<any>).map(SecurityAccessFeaturesEnumFromJSON)),
    };
}

export function AccessIntermediaryViewModelToJSON(value?: AccessIntermediaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IntermediaryCode': value.intermediaryCode,
        'FirstName': value.firstName,
        'LastName': value.lastName,
        'Features': ((value.features as Array<any>).map(SecurityAccessFeaturesEnumToJSON)),
    };
}

